import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import Specification from "@/assets/specification.svg";
import Location from "@/assets/location.svg";
import Proposal from "@/assets/proposal.svg";
import PurchaseOrder from "@/assets/purchase-order.svg";
import Invoice from "@/assets/file-invoice.svg";
import Overview from "@/assets/overview.png";
import Tasks from "@/assets/tasks.svg";
import Proc from "@/assets/procurement.svg";
import { MdArrowForwardIos } from "react-icons/md";
import useProjectStore from "@/utils/Stores/projectStore";
import { MdOutlineArrowBackIosNew } from "react-icons/md";
import { IoIosAddCircle, IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { FiCreditCard } from "react-icons/fi";
import Tooltip from "./Tooltip";
import Modal from "./Modal";
import CreateTask from "@/pages/Project/CreateTask";
const Sidebar = (props) => {
  const { projectID } = props;
  const navigate = useNavigate();
  const { id } = useParams();
  const projectData = useProjectStore((state: any) => state.projectData);
  const sidemenu = useProjectStore((state: any) => state.sidemenu);
  const toggleSideMenu = useProjectStore((state: any) => state.toggleSideMenu);
  const selectedMenu = useProjectStore((state: any) => state.selectedMenu);
  const setSelectedMenu = useProjectStore(
    (state: any) => state.setSelectedMenu
  );
  const [projectManagementDropdown, setProjectManagementDropdown] =
    useState(false);

  const navigationItems = [
    {
      label: "Project Details",
      icon: Overview,
      path: `/project/${id || projectID}/createproject`,
      showLine: false,
    },
    {
      label: "Locations",
      icon: Location,
      path: `/project/${id || projectID}/locations`,
      showLine: false,
    },
    {
      label: "Specification",
      icon: Specification,
      path: `/project/${id || projectID}/specifications`,
      showLine: true,
    },

    {
      label: "Proposals",
      icon: Proposal,
      path: `/project/${id || projectID}/proposals`,
      showLine: false,
    },
    {
      label: "Invoices",
      icon: Invoice,
      path: `/project/${id || projectID}/invoices`,
      showLine: true,
    },
    {
      label: "Credits & Retainers",
      icon: <FiCreditCard className="w-5 h-5" />,
      path: `/project/${id || projectID}/credits-retainers`,
    },

    {
      label: "Purchase Orders",
      icon: PurchaseOrder,
      path: `/project/${id || projectID}/purchaseorders`,
    },

    {
      label: "Project Management",
      icon: Tasks,
      children: [
        {
          label: "Tasks",
          // icon: Tasks,
          path: `/project/${id || projectID}/tasks`,
        },
        {
          label: "Order Tracking",
          // icon: Proc,
          path: `/project/${id || projectID}/tracking`,
        },
        {
          label: "Gantt Chart",
          // icon: <FaChartGantt className="text-gray-500" />,
          path: `/project/${id || projectID}/gantt`,
        },
      ],
    },
  ];

  useEffect(() => {
    const path = window.location.pathname;
    if (!selectedMenu) {
      // Map path to menu
      let menu = navigationItems?.find(
        (item) => item.path?.split("/")[3] === path?.split("/")[3]
      )?.label;

      setSelectedMenu(menu);
    }
  }, []);

  const toggleSidebar = () => {
    // setIsExpanded(!isExpanded);
    if (sidemenu) {
      setProjectManagementDropdown(false);
    }
    toggleSideMenu();
  };

  const handleMenuClick = (menu: string) => {
    setSelectedMenu(menu, selectedMenu);
  };

  const renderProjectMenu = (item, index) => {
    return (
      <>
        {item.path ? (
          <Link
            to={item.path}
            key={item.label}
            onClick={() => {
              !item.children && handleMenuClick(item.label);
              if (item.children) {
                setProjectManagementDropdown((prev) => !prev);
                !sidemenu && toggleSideMenu();
              }
            }}
          >
            {renderProjectMenuButton(item, index)}
          </Link>
        ) : (
          <div
            className="cursor-pointer"
            key={item.label}
            onClick={() => {
              !item.children && handleMenuClick(item.label);
              if (item.children) {
                setProjectManagementDropdown((prev) => !prev);
                !sidemenu && toggleSideMenu();
              }
            }}
          >
            {renderProjectMenuButton(item, index)}
          </div>
        )}
        {item.showLine && (
          <div className="flex justify-center">
            <div className="border-b border-customGrey-border2 w-full my-1"></div>
          </div>
        )}
        {item.children && projectManagementDropdown && (
          <div className="flex flex-col space-y-2 ps-5 font-lato text-black-secondary text-base font-medium">
            {item.children.map(renderProjectMenu)}
          </div>
        )}
      </>
    );
  };
  const renderProjectMenuButton = (item, index) => {
    return (
      <div
        className={`w-full flex items-center space-x-4 cursor-pointer p-2 mr-4 hover:text-gray-500 hover:bg-customGreen-bg ${!sidemenu ? " justify-center " : ""} hover:rounded-md ${
          item.label == selectedMenu ||
          item.children?.some((child) => child.label == selectedMenu)
            ? `text-customGreen-text bg-customGreen-bg rounded-md `
            : ""
        }`}
        onClick={() => item.path && navigate(item.path)}
      >
        {typeof item.icon === "string" ? (
          <img
            src={item.icon}
            alt={`${item.label} Icon`}
            className="max-w-[20px] max-h-fit"
            style={{
              filter:
                item.label == selectedMenu ||
                item.children?.some((child) => child.label == selectedMenu)
                  ? "brightness(0) saturate(100%) invert(43%) sepia(73%) saturate(331%) hue-rotate(120deg) brightness(93%) contrast(89%)"
                  : "",
            }}
          />
        ) : (
          <span
            style={{
              filter:
                item.label == selectedMenu
                  ? "brightness(0) saturate(100%) invert(43%) sepia(73%) saturate(331%) hue-rotate(120deg) brightness(93%) contrast(89%)"
                  : "",
            }}
          >
            {item.icon}
          </span>
        )}

        {sidemenu && (
          <span className=" whitespace-nowrap flex justify-between items-center">
            {item.label}
            {item.children && (
              <span className="ml-2 mt-0.5">
                {projectManagementDropdown ? (
                  <IoIosArrowUp />
                ) : (
                  <IoIosArrowDown />
                )}
              </span>
            )}
          </span>
        )}
      </div>
    );
  };

  return (
    <div
      className={`flex sticky top-[84px] flex-col p-4 border-r border-customGrey-primary bg-brand-25  ${
        sidemenu ? "w-64" : "w-24"
      } transition-all duration-300 ease-in-out z-[99]`}
      // style={{ height: isScrolled ? "100vh" : "calc(100vh - 84px)" }}
      style={{ height: "calc(100vh - 107px)" }}
    >
      {/* Toggle Button */}
      <button
        onClick={toggleSidebar}
        className="w-6 h-6 absolute -right-3 top-6 rounded-full bg-white flex justify-center items-center shadow-sm"
      >
        {sidemenu ? <MdOutlineArrowBackIosNew /> : <MdArrowForwardIos />}
      </button>

      {/* Project Name */}
      {sidemenu && (
        <div className="mb-8 text-left ">
          <h4
            className={`text-sm text-black-secondary font-semibold ${
              projectData?.name && " cursor-pointer "
            }`}
            onClick={() =>
              projectData?.name
                ? navigate(`/project/${id || projectID}/createproject`)
                : null
            }
          >
            {projectData?.name ?? "Project...."}
          </h4>
        </div>
      )}

      {/* Navigation Items */}
      <div className="flex flex-col space-y-2 font-lato text-black-secondary text-base font-medium">
        {navigationItems.map(renderProjectMenu)}
      </div>
    </div>
  );
};

export default Sidebar;
